export default __webpack_public_path__ + "static/media/search-bg.3c86ef97.png";